import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ShoppingBag } from "lucide-react";
import { SITE } from "@/data/site";
import { openWhatsApp } from "@/lib/whatsapp";

const NAV = [
  { id: "hakkimizda", label: "Hakkımızda" },
  { id: "hikayemiz", label: "Hikâyemiz" },
  { id: "urunler", label: "Ürünler" },
  { id: "koleksiyonlar", label: "Koleksiyonlar" },
  { id: "sss", label: "SSS" },
  { id: "iletisim", label: "İletişim" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 0.61, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled ? "navbar-glass py-2" : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <button
          data-testid="brand-link"
          onClick={() => handleNav("home")}
          className="flex items-center gap-3 group"
          aria-label="NovaLand ana sayfa"
        >
          <img src="/logo-cream.jpg" alt="NovaLand" className="h-10 w-10 rounded-full object-cover ring-1 ring-[hsl(var(--nl-champagne)/0.5)]" />
          <div className="flex flex-col leading-tight text-left">
            <span className="font-display text-xl tracking-wide text-[hsl(var(--nl-anthracite))]">{SITE.brand}</span>
            <span className="text-[10px] uppercase tracking-[0.35em] gold-text">Aksesuar &amp; Takı</span>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => handleNav(n.id)}
              className="text-sm tracking-wide text-[hsl(var(--nl-anthracite))] hover:gold-text transition-colors"
            >
              {n.label}
            </button>
          ))}
          <a
            data-testid="nav-shopier"
            href={SITE.social.shopier}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden xl:inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.18em] gold-text hover:text-[hsl(var(--nl-anthracite))] transition-colors border-b border-[hsl(var(--nl-champagne)/0.5)] hover:border-[hsl(var(--nl-anthracite))] pb-1"
          >
            <ShoppingBag size={13} /> Shopier
          </a>
          <button
            data-testid="nav-whatsapp"
            onClick={() => openWhatsApp()}
            className="btn-gold !py-2.5 !px-4 !text-[11px]"
          >
            <span>WhatsApp</span>
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden p-2 text-[hsl(var(--nl-anthracite))]"
          aria-label="Menüyü aç/kapat"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="lg:hidden navbar-glass overflow-hidden border-t border-[hsl(var(--nl-line)/0.6)]"
          >
            <div className="px-6 py-5 flex flex-col gap-4">
              {NAV.map((n) => (
                <button
                  key={n.id}
                  data-testid={`mobile-nav-${n.id}`}
                  onClick={() => handleNav(n.id)}
                  className="text-left text-base text-[hsl(var(--nl-anthracite))] hover:gold-text"
                >
                  {n.label}
                </button>
              ))}
              <button
                data-testid="mobile-nav-whatsapp"
                onClick={() => { setOpen(false); openWhatsApp(); }}
                className="btn-gold w-fit"
              >
                <span>WhatsApp ile İletişim</span>
              </button>
              <a
                data-testid="mobile-nav-shopier"
                href={SITE.social.shopier}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setOpen(false)}
                className="btn-outline w-fit"
              >
                <ShoppingBag size={14} /> <span>Shopier Mağaza</span>
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navbar;
